import { render, staticRenderFns } from "./TableEndorsementDeductions.vue?vue&type=template&id=02ccbb06&scoped=true&"
import script from "./TableEndorsementDeductions.vue?vue&type=script&lang=js&"
export * from "./TableEndorsementDeductions.vue?vue&type=script&lang=js&"
import style0 from "./TableEndorsementDeductions.vue?vue&type=style&index=0&id=02ccbb06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ccbb06",
  null
  
)

export default component.exports